import { api, languageApi } from '@/config';
import axios from 'axios';

export default {
  async  getSurvayVaildTime(body) {
    try {
      const res = await axios.put(`${api}/api/v1/form-endtime`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getSurvayTemplate(params) {
    try {
      const res = await axios.get(`${api}/api/v1/Form`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  // AnswerList,ReplyID
  async putSurvayAnswer(body) {
    try {
      const res = await axios.put(`${api}/api/v1/form-result`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getLanguageWording(params) {
    try {
      const res = await axios.get(`${languageApi}/api/Language`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getFormParams(params) {
    try {
      const res = await axios.get(`${api}/api/FormParam`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getCompanyParams(params) {
    try {
      const res = await axios.get(`${api}/api/v1/company-parameter`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getFormCompany(params) {
    try {
      const res = await axios.get(`${api}/api/v1/form-company`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getFormLinkUrl(body) {
    try {
      const res = await axios.post(`${api}/api/v1/form-result`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
